export default __webpack_public_path__ + "static/media/Diver.f2b1ac3b.mp3";